import { useState } from 'react';

function UseTokenComponent() {
    // This function retrieves the token if stored in localStorage
    // Only returns a token if it exists hence the use of the && (AND) conditional operator
    function getToken() {
        const userToken = localStorage.getItem("token")
        return userToken && userToken
    }

    // This hook handles the state of the token variable
    // Ensures the React app will always relaod when any of the functions are called
    const [token, setToken] = useState(getToken())

    // Handles storage of token obtained when user logs in
    // setToken updates state of token variable
    function saveToken(userToken, username) {
        localStorage.setItem("token", userToken)
        localStorage.setItem("username", username)
        setToken(userToken)
    }

    // Deletes token from local storage and returns token back to null state
    function removeToken() {
        localStorage.removeItem("token")
        setToken(null)
    }

    // saveToken function assigned as a value to the setToken variable
    // value of the token itself and removeToken function are returned as a result of calling the useToken function
    return {
        saveToken,
        token,
        removeToken
    }

}

export default UseTokenComponent